module.exports = function(column) {

   return this.sortable(column)?'VueTables__sortable':'';

}



// WEBPACK FOOTER //
// ./~/vue-tables-2/lib/methods/sortable-class.js